import { graphql } from 'gatsby';
import React from 'react';

import SEO from '../components/seo';
import Subheader from '../components/subheader';
import { GraphQLData } from '../types';
import { getLocalizationObj } from '../utilities/getLocalizationObj';
import { LeistungenTemplateMain } from './leistungenMain';

interface LeistungenProps {
  data: GraphQLData;
  location: any;
}

export const LeistungenTemplate = ({ location, data }: LeistungenProps) => {
  const { subheader, meta } = getLocalizationObj(data.strapi?.service) || {};
  const { title = 'Leistungen', description } = meta ?? {};

  return (
    <>
      <SEO description={description} title={title} />
      <Subheader intro={subheader} />
      <LeistungenTemplateMain data={data} location={location} />
    </>
  );
};
